// Map a car photo URL to its sized WebP copy (skyway-functions F1).
// images/<name>.<ext> -> sized/v1/<name>_{400,800,1200}.webp on the CDN.
const CDN = 'https://cdn.skywayclassics.com/';
const BUCKET = 'skyway-dev-373d5';

const safeDecode = (value) => {
  try { return decodeURIComponent(value); } catch { return value; }
};

export const photoObjectName = (url) => {
  if (typeof url !== 'string') return null;
  const trimmed = url.trim();
  let path = null;
  const cdn = trimmed.match(/^https?:\/\/cdn\.skywayclassics\.com\/([^?#]+)/i);
  if (cdn) path = safeDecode(cdn[1]);
  if (!path) {
    const gcs = trimmed.match(new RegExp(`^https?://storage\\.googleapis\\.com/${BUCKET}/([^?#]+)`, 'i'));
    if (gcs) path = safeDecode(gcs[1]);
  }
  if (!path) return null;
  path = path.replace(/^\/+/, '');
  if (!path.startsWith('images/') || path.endsWith('/')) return null;
  return path;
};

export const sizedPhotoUrl = (url, width) => {
  const name = photoObjectName(url);
  if (!name) return null;
  const rel = name.slice('images/'.length);
  const slash = rel.lastIndexOf('/');
  const file = slash >= 0 ? rel.slice(slash + 1) : rel;
  const dot = file.lastIndexOf('.');
  if (dot <= 0 || dot === file.length - 1) return null;
  const stem = rel.slice(0, rel.length - (file.length - dot));
  const encoded = stem.split('/').map(encodeURIComponent).join('/');
  return `${CDN}sized/v1/${encoded}_${width}.webp`;
};
